import Plan        from "../../plan/Plan";
import Reservation from "../Reservation";

class ReservationHistory {
  constructor(
    private readonly _reservation: Reservation = new Reservation(),
    private readonly _plan: Plan = new Plan(),
  ) {
  }

  get reservation() {
    return this._reservation;
  }

  get plan() {
    return this._plan;
  }
}

export default ReservationHistory;
